export enum ICourseStatus {
    Draft = 1,
    Published = 2,
    NotListed = 3,
    Launched = 4
}